module.exports = "https://99designs-start-assets.imgix.net/js/42ec8862fc69e75f5b849fa0a71d699a.png";